var modules_80570563 = {"container":"_15vaz0w","button":"_382dnb","active":"_1ngmq7r","disabled":"_1we0jhb","size-36":"_wbm8k4","size-44":"_1a4945b","size-52":"_zzif29","with-border":"_ghrju5"};
import "../../../assets/gXViU4hP.css";

export { modules_80570563 as default };
//# sourceMappingURL=RadioButton.module.less.js.map
